import { Component, OnInit } from '@angular/core';
import { PontoCombinadoResponse, PontoService } from '../../../services/expediente.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-historioco-expediente',
  standalone: false,
  templateUrl: './historioco-expediente.component.html',
  styleUrls: ['./historioco-expediente.component.css']
})
export class HistoriocoExpedienteComponent implements OnInit {
  historico: PontoCombinadoResponse[] = [];
  historicoFiltrado: PontoCombinadoResponse[] = [];
  nomesUsuarios: string[] = []; // <-- Adicionado

  carregando = false;
  erro: string | null = null;

  // Filtros
  filtroNome: string = '';
  filtroDataInicio: string = this.getDataHojeInput();
  filtroDataFim: string = this.getDataHojeInput();
  filtroDataInicioTexto: string = this.getDataHojeFormatada();
  filtroDataFimTexto: string = this.getDataHojeFormatada();

  exportMenuAberto = false;
  exportIconAnimando = false;
  exportIconOk = false;

  constructor(private pontoService: PontoService) { }

  ngOnInit(): void {
    this.carregando = true;
    this.pontoService.consultarTodosPontosCombinados().subscribe({
      next: (dados) => {
        this.historico = dados;
        this.nomesUsuarios = Array.from(
          new Set(dados.map(p => p.nome).filter(n => !!n))
        ).sort();
        this.aplicarFiltro(); // Aplica o filtro do dia ao carregar
        this.carregando = false;
      },
      error: (err) => {
        this.erro = 'Erro ao carregar os registros de ponto.';
        console.error('❌ Erro:', err);
        this.carregando = false;
      }
    });
  }
  formatarHorasTrabalhadas(horas: string): string {
    if (!horas) return '-';
    const partes = horas.split(':');
    const hh = (partes[0] ?? '00').padStart(2, '0');
    const MM = (partes[1] ?? '00').padStart(2, '0');
    const ss = (partes[2]?.substring(0,2) ?? '00').padStart(2, '0');
    return `${hh}:${MM}:${ss}`;
  }
  resetarFiltro(): void {
    this.filtroNome = '';
    this.filtroDataInicio = this.getDataHojeInput();
    this.filtroDataFim = this.getDataHojeInput();
    this.filtroDataInicioTexto = this.getDataHojeFormatada();
    this.filtroDataFimTexto = this.getDataHojeFormatada();
    this.aplicarFiltro(); // chama o método padrão de filtro
  }
  formatarCoordenada(valor: number): string {
    if (!valor || isNaN(valor) || valor === 0) return '';
    // Se já estiver no formato decimal, retorna direto
    if (Math.abs(valor) < 90) return valor.toString();
    // Se vier inteiro, converte
    return (valor / 1e7).toFixed(7);
  }

  aplicarFiltro(): void {
    const nome = this.filtroNome;

    // Converter filtro para Date com controle de tempo
    const dataInicio = this.filtroDataInicio ? new Date(this.filtroDataInicio + 'T00:00:00') : null;
    const dataFim = this.filtroDataFim ? new Date(this.filtroDataFim + 'T23:59:59') : null;


    this.historicoFiltrado = this.historico
      .filter(ponto => {
        const nomeValido = !nome || ponto.nome === nome;
        const dataExpediente = new Date(ponto.inicioExpediente);
        const dataValida =
          (!dataInicio || dataExpediente >= dataInicio) &&
          (!dataFim || dataExpediente <= dataFim);
        return nomeValido && dataValida;
      })
      .sort((a, b) => {
        const dataA = new Date(a.inicioExpediente).getTime();
        const dataB = new Date(b.inicioExpediente).getTime();
        return dataB - dataA; // Mais recente primeiro
      });

    // Atualiza texto do filtro para exibir dd-MM-yyyy
    this.filtroDataInicioTexto = this.formatarDataTexto(this.filtroDataInicio);
    this.filtroDataFimTexto = this.formatarDataTexto(this.filtroDataFim);
  }

  exportarCSV(): void {
    this.exportIconAnimando = true;
    this.exportIconOk = false;
    setTimeout(() => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Histórico');

      worksheet.addRow([
        'Nome', 'Data', 'Início', 'Pausa', 'Retorno', 'Fim', 'Total Horas',
        'Latitude Início', 'Longitude Início', 'Latitude Fim', 'Longitude Fim'
      ]);

      const linhas: string[][] = [];

      // Cabeçalho
      linhas.push([
        'Nome', 'Data', 'Início', 'Pausa', 'Retorno', 'Fim', 'Total Horas',
        'Latitude Início', 'Longitude Início', 'Latitude Fim', 'Longitude Fim'
      ]);

      this.historicoFiltrado.forEach(ponto => {
        linhas.push([
          ponto.nome || 'Usuário N/A',
          this.formatarDataTexto(ponto.inicioExpediente?.split('T')?.[0] || ''),
          this.formatarHora(ponto.inicioExpediente),
          this.formatarHora(ponto.inicioPausa),
          this.formatarHora(ponto.retornoPausa),
          this.formatarHora(ponto.fimExpediente),
          this.formatarHorasTrabalhadas(ponto.horasTrabalhadas),
          this.formatarCoordenada(ponto.latitudeInicioExpediente),
          this.formatarCoordenada(ponto.longitudeInicioExpediente),
          this.formatarCoordenada(ponto.latitudeFimExpediente),
          this.formatarCoordenada(ponto.longitudeFimExpediente)
        ]);

      });

      const csvContent = linhas.map(e => e.join(';')).join('\n');
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const tempoMinimo = 1000;
      const inicio = Date.now();

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'historico_expediente.csv');
      document.body.appendChild(link);

      const tempoPassado = Date.now() - inicio;
      const tempoRestante = Math.max(0, tempoMinimo - tempoPassado);

      setTimeout(() => {
        link.click();
        document.body.removeChild(link);

        this.exportIconAnimando = false;
        this.exportIconOk = true;
        setTimeout(() => this.exportIconOk = false, 1000); // ok some após 1.2s
      }, tempoRestante);
    }, 0);
  }


  exportarExcel(): void {
    this.exportIconAnimando = true;
    this.exportIconOk = false;

    setTimeout(() => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Histórico');

      worksheet.addRow([
        'Nome', 'Data', 'Início', 'Pausa', 'Retorno', 'Fim', 'Total Horas',
        'Latitude Início', 'Longitude Início', 'Latitude Fim', 'Longitude Fim'
      ]);

      this.historicoFiltrado.forEach(ponto => {
        worksheet.addRow([
          ponto.nome || 'Usuário N/A',
          this.formatarDataTexto(ponto.inicioExpediente?.split('T')?.[0] || ''),
          this.formatarHora(ponto.inicioExpediente),
          this.formatarHora(ponto.inicioPausa),
          this.formatarHora(ponto.retornoPausa),
          this.formatarHora(ponto.fimExpediente),
          this.formatarHorasTrabalhadas(ponto.horasTrabalhadas),
          this.formatarCoordenada(ponto.latitudeInicioExpediente),
          this.formatarCoordenada(ponto.longitudeInicioExpediente),
          this.formatarCoordenada(ponto.latitudeFimExpediente),
          this.formatarCoordenada(ponto.longitudeFimExpediente)
        ]);

      });

      // 🔽 Aqui entra o delay mínimo de 800ms para manter a animação visível
      const tempoMinimo = 1000;
      const inicio = Date.now();

      workbook.xlsx.writeBuffer().then((buffer) => {
        const tempoPassado = Date.now() - inicio;
        const tempoRestante = Math.max(0, tempoMinimo - tempoPassado);

        setTimeout(() => {
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          saveAs(blob, 'historico_expediente.xlsx');
          this.exportIconAnimando = false;
          this.exportIconOk = true;
          setTimeout(() => this.exportIconOk = false, 1000); // ok some após 1.2s
        }, tempoRestante);
      });
    }, 0); // 🔁 ainda necessário para renderizar a animação antes de processar
  }



  informarSemCoordenada(tipo: 'início' | 'fim') {
    Swal.fire({
      title: 'Sem localização',
      text: `Não há coordenadas registradas para o ${tipo} do expediente.`,
      icon: 'warning',
      confirmButtonText: 'OK'
    });
  }

  toggleExportMenu(): void {
    this.exportMenuAberto = !this.exportMenuAberto;
  }

  animarIconeExportacao(): void {
    this.exportIconAnimando = true;
    setTimeout(() => {
      this.exportIconAnimando = false;
    }, 800); // duração da animação em ms
  }

  getDataHojeFormatada(): string {
    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, '0');
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    const ano = hoje.getFullYear();
    return `${dia}-${mes}-${ano}`;
  }

  getDataHojeInput(): string {
    const hoje = new Date();
    return hoje.toISOString().split('T')[0]; // yyyy-MM-dd
  }

  getDataSeteDiasAtrasInput(): string {
    const hoje = new Date();
    const seteDiasAtras = new Date(hoje);
    seteDiasAtras.setDate(hoje.getDate() - 6); // Inclui hoje, então -6
    return seteDiasAtras.toISOString().split('T')[0];
  }

  getDataSeteDiasAtrasFormatada(): string {
    const hoje = new Date();
    const seteDiasAtras = new Date(hoje);
    seteDiasAtras.setDate(hoje.getDate() - 6);
    const dia = String(seteDiasAtras.getDate()).padStart(2, '0');
    const mes = String(seteDiasAtras.getMonth() + 1).padStart(2, '0');
    const ano = seteDiasAtras.getFullYear();
    return `${dia}-${mes}-${ano}`;
  }

  formatarDataTexto(data: string): string {
    // data: yyyy-MM-dd
    if (!data) return '';
    const [ano, mes, dia] = data.split('-');
    if (ano && mes && dia) return `${dia}-${mes}-${ano}`;
    return data;
  }


  formatarHora(data: any): string {
    if (!data) return ''; // Se for null, undefined, vazio, 0, retorna vazio
    const dt = new Date(data);
    if (isNaN(dt.getTime())) return ''; // Se não é data válida, retorna vazio
    // Só exibe hora:minuto (sem segundos, mais limpo)
    return dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  }

}
